import React, { useEffect, useState } from 'react';
import { Dialog, IconButton, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Switch, Menu, Fade, MenuItem, Snackbar, Avatar, Box,  Grid } from '@material-ui/core';
import { MoreVert, PersonAddOutlined } from '@material-ui/icons';
import {  EmailAuthProvider, createUserWithEmailAndPassword, reauthenticateWithCredential, reauthenticateWithPopup, sendPasswordResetEmail, signInWithEmailAndPassword, signInWithPopup, signOut, updateEmail, updateProfile, verifyBeforeUpdateEmail } from 'firebase/auth';
import { Alert } from '@material-ui/lab';
import { auth, db, googleAuthProvider } from '../../config/firebase';
import { addMessage } from '../../api/firebaseStore';
import { addDoc, collection, doc,  getDocs, query, updateDoc, where } from 'firebase/firestore';
import { FcGoogle } from "react-icons/fc";

function LoginButton({ setShowChatContainer, resetBot }) {
    const [firebaseLoading, setFirebaseLoading] = useState(false);
    const [open, setOpen] = useState(auth.currentUser ? false : true);
    const [profileOpen, setProfileOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [rtrPassEmail, setRtrPassEmail] = useState('');
    const [resetEmailSentSnackbarOpen, setResetEmailSentSnackbarOpen] = useState(false);
    const [resetEmailOpen, setResetEmailOpen] = useState(false);
    const [resetPasswordOpen, setResetPasswordOpen] = useState(false);

    const [currentUuidInProfile, setCurrentUuidInProfile] = useState();

    const [signingUp, setSigningUp] = useState(false);
    const [userProfileId, setUserProfileId] = useState();
    const [userDisplayName, setUserDisplayName] = useState('Login');
    const [errorMessage, setErrorMessage] = useState();
    const [errorSeverity, setErrorSeverity] = useState('error');
    const [resetEmailInputs, setResetEmailInputs] = useState({
        currentPassword: '',
        newEmail: ''
    });


    const [userInputs, setUserInputs] = useState({
        email: '',
        displayName: '',
        password: '',
        password2: ''
    });
    const [profileInputs, setProfileInputs] = useState({
        // email: auth.currentUser ? auth.currentUser.email : '',
        displayName: auth.currentUser ? auth.currentUser.displayName : '',
        lastName: '',
        firstName: '',
        metarunId: '',
        cnName: '',
        gender: '',
        birthYear: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        country: ''
    });

    useEffect(() => {
        async function initCurrentUser() {
            if (auth.currentUser) {
                setShowChatContainer(true);
                setOpen(false);
                setUserDisplayName(auth.currentUser.displayName.length > 0 ? auth.currentUser.displayName : 'me');
                // find by uuid
                const q = query(collection(db, 'users'), where('uuid', '==', auth.currentUser.uid));
                const querySnapshot = await getDocs(q);
                if (querySnapshot.docs.length > 0) {
                    setCurrentUuidInProfile(querySnapshot.docs.at(0).data().uuid);
                    setUserProfileId(querySnapshot.docs.at(0).id);
                    setProfileInputs(
                        {
                            // email: auth.currentUser.email,
                            displayName: auth.currentUser.displayName,
                            metarunId: querySnapshot.docs.at(0).data().ID,
                            cnName: querySnapshot.docs.at(0).data().CN_NAME,
                            firstName: querySnapshot.docs.at(0).data().First_Name,
                            lastName: querySnapshot.docs.at(0).data().Last_Name,
                            gender: querySnapshot.docs.at(0).data().Gender,
                            birthYear: querySnapshot.docs.at(0).data().birth_year,
                            phone: querySnapshot.docs.at(0).data().phone,
                            address: querySnapshot.docs.at(0).data().address,
                            city: querySnapshot.docs.at(0).data().City,
                            state: querySnapshot.docs.at(0).data().State,
                            country: querySnapshot.docs.at(0).data().Country
                        }
                    );
                } else {
                    // login with oath2
                    setProfileInputs(
                        {
                            // email: auth.currentUser ? auth.currentUser.email : '',
                            displayName: auth.currentUser ? auth.currentUser.displayName : '',
                            lastName: '',
                            firstName: '',
                            metarunId: '',
                            cnName: '',
                            gender: '',
                            birthYear: '',
                            phone: '',
                            address: '',
                            city: '',
                            state: '',
                            country: ''
                        }
                    );
                }
            } else {
                setUserDisplayName(null);
            }
        }
        initCurrentUser();
    }, [auth.currentUser, currentUuidInProfile]);

    const setErrorMessageWithoutFirebase = (errorMessage) => {
        setErrorMessage(errorMessage.replace("Firebase: ", '').trim());
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleMenuClose = () => {
        setMenuOpen(false);
    }

    const handleClose = () => {
        setOpen(false);
        setProfileOpen(false);
        setResetEmailOpen(false);
        setResetPasswordOpen(false);
        setErrorMessage('');
    };

    const handleUserInput = (propName, theInputValue) => {
        userInputs[propName] = theInputValue;
        setUserInputs(
            {
                email: userInputs.email,
                displayName: userInputs.displayName,
                password: userInputs.password,
                password2: userInputs.password2,
                [propName]: theInputValue
            }
        );
    }

    const handleProfileInput = (propName, theInputValue) => {
        profileInputs[propName] = theInputValue;
        setProfileInputs(
            {
                // email: profileInputs.email,
                displayName: profileInputs.displayName,
                lastName: profileInputs.lastName,
                firstName: profileInputs.firstName,
                metarunId: profileInputs.metarunId,
                cnName: profileInputs.cnName,
                gender: profileInputs.gender,
                birthYear: profileInputs.birthYear,
                phone: profileInputs.phone,
                address: profileInputs.address,
                city: profileInputs.city,
                state: profileInputs.state,
                country: profileInputs.country,
                [propName]: theInputValue
            }
        );
    }


    // this method to process legacy data from metarun. They do not have a uuid in firebase, so we add it here
    const addUuidToUserProfile = async () => {
        const q = query(collection(db, 'users'), where('Email', '==', auth.currentUser.email));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.docs.length > 0) {
            // no uuid here, add it
            if (!querySnapshot.docs.at(0).data().uuid) {
                console.log('addUuidToUserProfile: ', auth.currentUser.email, auth.currentUser.uid);
                await updateDoc(doc(db, 'users', querySnapshot.docs.at(0).id), {
                    uuid: auth.currentUser.uid
                });
                setCurrentUuidInProfile(auth.currentUser.uid);
            }
        }
    }

    const handleUpdateProfile = async () => {
        setFirebaseLoading(true);
        // new display name: we need update google auth profile displayName
        console.log('update profile displayName ', auth.currentUser.displayName, profileInputs.displayName);
        if (profileInputs.displayName && profileInputs.displayName !== auth.currentUser.displayName) {
            await updateProfile(auth.currentUser, {
                displayName: profileInputs.displayName
            });
            setUserDisplayName(auth.currentUser.displayName);
        }
        //update email (CAN NOT DO THIS HERE due to email enumeration of Google)

        // if (profileInputs.email && profileInputs.email !== auth.currentUser.email) {
        //     await updateEmail(auth.currentUser, profileInputs.email.trim());
        //     setUserProfileId(null);
        // }

        // update user profile in firestore
        if (userProfileId) {
            await updateDoc(doc(db, 'users', userProfileId), {
                Last_Name: profileInputs.lastName,
                First_Name: profileInputs.firstName,
                CN_NAME: profileInputs.cnName,
                Gender: profileInputs.gender,
                birth_year: profileInputs.birthYear,
                phone: profileInputs.phone,
                address: profileInputs.address,
                City: profileInputs.city,
                State: profileInputs.state,
                Country: profileInputs.country,
                uuid: auth.currentUser.uid
            });
        } else {
            // for oath2 login, new user profile in firestore should be created if there is no userProfileId
            console.log('for oath2 login, new user profile in firestore should be created if there is no userProfileId');
            await addDoc(collection(db, "users"), {
                Email: auth.currentUser.email,
                Last_Name: profileInputs.lastName,
                First_Name: profileInputs.firstName,
                CN_NAME: profileInputs.cnName,
                Gender: profileInputs.gender,
                birth_year: profileInputs.birthYear,
                phone: profileInputs.phone,
                address: profileInputs.address,
                City: profileInputs.city,
                State: profileInputs.state,
                Country: profileInputs.country,
                uuid: auth.currentUser.uid
            });
        }

        setFirebaseLoading(false);
        handleClose();
    }

    const handleLogin = async () => {
        setFirebaseLoading(true);
        if (!signingUp) {
            signInWithEmailAndPassword(auth, userInputs.email, userInputs.password).then((userCredential) => {
                addUuidToUserProfile();
                setFirebaseLoading(false);
                resetBot();
                setShowChatContainer(true);
                handleClose();
                addMessage(userCredential.user.uid, userCredential.user.email, "user", Date.now(), `${userCredential.user.email} login.`, '');
                // setUserDisplayName(auth.currentUser.displayName)
            }).catch((error) => {
                setFirebaseLoading(false);
                setErrorMessageWithoutFirebase(error.message);
            });
        } else {
            if (userInputs.password !== userInputs.password2) {
                setErrorMessageWithoutFirebase('Passwords not same.');
            } else {
                console.log('signing up');

                /**The code is to import meta-run runners */
                // const interval = 40000;
                // metarun_users.forEach(async (runner, index) => {
                //     setTimeout(async function () {
                //         console.log(runner.Email);
                //         try {
                //             await createUserWithEmailAndPassword(auth, runner.Email, 'metarun_' + runner.Email.split('@')[0]);
                //         } catch (error) {
                //             setErrorMessageWithoutFirebase(error.message);
                //             return;
                //         }

                //         try {
                //             // console.log('updateProfile: ', runner.First_Name, runner.CN_NAME);
                //             const dName = runner.First_Name.trim().length > 0 ? runner.First_Name : runner.CN_NAME;
                //             await updateProfile(auth.currentUser, {
                //                 displayName: dName
                //             });
                //         } catch (error) {
                //             setErrorMessageWithoutFirebase(error.message);
                //             return;
                //         }
                //     }, index * interval);
                // })

                try {
                    await createUserWithEmailAndPassword(auth, userInputs.email, userInputs.password);
                } catch (error) {
                    setErrorMessageWithoutFirebase(error.message);
                    setFirebaseLoading(false);
                    return;
                }

                try {
                    await updateProfile(auth.currentUser, {
                        displayName: userInputs.displayName
                    });
                } catch (error) {
                    setErrorMessageWithoutFirebase(error.message);
                    setFirebaseLoading(false);
                    return;
                }
                setFirebaseLoading(false);
                resetBot();
                setShowChatContainer(true);
                handleClose();
            }
        }
    };

    const handleLoginWithGoogle = () => {
        signInWithPopup(auth, googleAuthProvider).then((userCredential) => {
            resetBot();
            setShowChatContainer(true);
            handleClose();
            addMessage(userCredential.user.uid, userCredential.user.email, "user", Date.now(), `${userCredential.user.email} login.`, '');
        }).catch((error) => {
            setErrorMessageWithoutFirebase(error.message);
        });
    };

    const handleLogout = () => {
        signOut(auth).then(() => {
            setUserDisplayName('Login');
            setProfileInputs({});
            setUserProfileId(null);
            setFirebaseLoading(false);
            setOpen(true);
            setShowChatContainer(false);
            setCurrentUuidInProfile('');
            console.log('Sign out...');
        }).catch((error) => {
        });
    };

    return <div>
        {
            !auth.currentUser &&
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="subtitle2">Login</Typography>
                <IconButton onClick={handleClickOpen} color="primary" aria-label="Profile" component="span">
                    <PersonAddOutlined style={{ color: '#1EB0BC' }} />
                </IconButton>
            </div>
        }
        {
            auth.currentUser &&
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {auth.currentUser.photoURL ?
                    <Avatar alt={userDisplayName} src={auth.currentUser.photoURL} /> :
                    <Typography variant="subtitle2">{userDisplayName} </Typography>}

                <IconButton

                    aria-controls="fade-menu" aria-haspopup="true"
                    onClick={(e) => {
                        setAnchorEl(e.currentTarget);
                        setMenuOpen(true);
                    }}
                >
                    <MoreVert style={{ color: '#1EB0BC' }} />
                </IconButton>
                {/* <IconButton onClick={handleLogout} color="primary" aria-label="Profile" component="span">
                    <ExitToAppOutlined style={{ color: '#1EB0BC' }} />
                </IconButton> */}
            </div>
        }

        {/* Menu for top right 3 dots */}
        <Menu
            id="fade-menu"
            anchorEl={anchorEl}
            keepMounted
            open={menuOpen}
            onClose={handleMenuClose}
            TransitionComponent={Fade}
        >
            <MenuItem onClick={() => {
                handleMenuClose();
                setProfileOpen(true);
            }}>Profile</MenuItem>
            <MenuItem onClick={() => {
                handleMenuClose();
                setResetEmailOpen(true);
            }}>Reset Email</MenuItem>
            <MenuItem onClick={() => {
                sendPasswordResetEmail(auth, auth.currentUser.email).then(() => {
                    handleMenuClose();
                    setResetEmailSentSnackbarOpen(true);
                })
            }}>Reset Password</MenuItem>
            <MenuItem onClick={() => {
                handleMenuClose();
                handleLogout();
            }}>Logout</MenuItem>
        </Menu>

        {/* Display a snackbar to notify the reset password email has been sent */}
        <Snackbar
            anchorOrigin={
                { vertical: 'top', horizontal: 'center' }
            }
            open={resetEmailSentSnackbarOpen} autoHideDuration={6000} onClose={() => {
                setResetEmailSentSnackbarOpen(false)
            }}>
            <Alert variant='filled'>Password reset email sent to {auth.currentUser ? auth.currentUser.email : 'your email'}!</Alert>
        </Snackbar>


        {/* Dialog for reset password */}
        <Dialog open={resetPasswordOpen} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Forgot Password</DialogTitle>
            <DialogContent>
                <TextField variant="outlined"
                    autoFocus
                    margin="dense"
                    label="Your Email"
                    type="email"
                    fullWidth
                    value={rtrPassEmail}
                    onChange={(e) => {
                        setRtrPassEmail(e.target.value);
                    }}
                />
                {
                    errorMessage && <Alert severity={errorSeverity}>{errorMessage}</Alert>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                    setResetPasswordOpen(false);
                    setOpen(true);
                    setSigningUp(false);
                    setErrorMessage('');
                }} color="primary">
                    Goto Login
                </Button>
                <Button
                    disabled={'Password reset email sent!' === errorMessage}
                    onClick={() => {
                        try {
                            sendPasswordResetEmail(auth, rtrPassEmail).then(() => {
                                setErrorMessage("Password reset email sent!");
                                setErrorSeverity("success");
                            });
                        } catch (error) {
                            setErrorSeverity("error");
                            setErrorMessage("Error occurs...");
                        }
                    }} color="primary">
                    Submit
                </Button>
            </DialogActions>
        </Dialog>

        {/* Dialog for reset email */}
        <Dialog open={resetEmailOpen} onClose={handleClose} aria-labelledby="form-dialog-title" >
            <DialogTitle id="form-dialog-title">Reset Email</DialogTitle>
            <DialogContent>
                <TextField variant="outlined"
                    autoFocus
                    margin="dense"
                    label="Current Password"
                    type="password"
                    fullWidth
                    value={resetEmailInputs.currentPassword}
                    onChange={(e) => {
                        setResetEmailInputs(
                            {
                                currentPassword: e.target.value,
                                newEmail: resetEmailInputs.newEmail
                            }
                        );
                    }}
                />
                <TextField variant="outlined"
                    autoFocus
                    margin="dense"
                    label="New Email"
                    type="email"
                    fullWidth
                    value={resetEmailInputs.newEmail}
                    onChange={(e) => {
                        setResetEmailInputs(
                            {
                                currentPassword: resetEmailInputs.currentPassword,
                                newEmail: e.target.value
                            }
                        );
                    }}
                />
                {
                    errorMessage && <Alert severity={errorSeverity}>{errorMessage}</Alert>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} style={{ color: '#1EB0BC' }}>
                    Cancel
                </Button>
                <Button onClick={async () => {
                    try {
                        await reauthenticateWithCredential(auth.currentUser, EmailAuthProvider.credential(auth.currentUser.email, resetEmailInputs.currentPassword));
                        await verifyBeforeUpdateEmail(auth.currentUser, resetEmailInputs.newEmail);
                        setErrorMessage("Confirm Email Sent!");
                        setErrorSeverity("success");
                    } catch (error) {
                        setErrorSeverity("error");
                        setErrorMessage("Error occurs...");
                    }

                }} style={{ color: '#1EB0BC' }}>
                    Reset Email
                </Button>
            </DialogActions>
        </Dialog>


        {/* Dialog for profile */}
        <Dialog open={profileOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Profile</DialogTitle>
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <TextField variant="outlined"
                            autoFocus
                            margin="dense"
                            label="Email"
                            type="email"
                            fullWidth
                            value={auth.currentUser ? auth.currentUser.email : ''}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField variant="outlined"
                            autoFocus
                            margin="dense"
                            label="First Name"
                            fullWidth
                            value={profileInputs.firstName}
                            onChange={(e) => {
                                handleProfileInput('firstName', e.target.value);
                            }}
                        /></Grid>
                    <Grid item xs={6}>
                        <TextField variant="outlined"
                            autoFocus
                            margin="dense"
                            label="Last Name"
                            fullWidth
                            value={profileInputs.lastName}
                            onChange={(e) => {
                                handleProfileInput('lastName', e.target.value);
                            }}
                        /></Grid>
                    <Grid item xs={6}>
                        <TextField variant="outlined"
                            autoFocus
                            margin="dense"
                            label="Gender"
                            fullWidth
                            value={profileInputs.gender}
                            onChange={(e) => {
                                handleProfileInput('gender', e.target.value);
                            }}
                        /></Grid>
                    <Grid item xs={6}>
                        <TextField variant="outlined"
                            autoFocus
                            margin="dense"
                            label="Birth Year"
                            fullWidth
                            value={profileInputs.birthYear}
                            onChange={(e) => {
                                handleProfileInput('birthYear', e.target.value);
                            }}
                        /></Grid>
                    <Grid item xs={12}>
                        <TextField variant="outlined"
                            autoFocus
                            margin="dense"
                            label="Phone"
                            fullWidth
                            value={profileInputs.phone}
                            onChange={(e) => {
                                handleProfileInput('phone', e.target.value);
                            }}
                        /></Grid>
                    <Grid item xs={12}>
                        <TextField variant="outlined"
                            autoFocus
                            margin="dense"
                            label="Address"
                            fullWidth
                            value={profileInputs.address}
                            onChange={(e) => {
                                handleProfileInput('address', e.target.value);
                            }}
                        /></Grid>
                    <Grid item xs={6}>
                        <TextField variant="outlined"
                            autoFocus
                            margin="dense"
                            label="City"
                            fullWidth
                            value={profileInputs.city}
                            onChange={(e) => {
                                handleProfileInput('city', e.target.value);
                            }}
                        /></Grid>
                    <Grid item xs={6}>
                        <TextField variant="outlined"
                            autoFocus
                            margin="dense"
                            label="State"
                            fullWidth
                            value={profileInputs.state}
                            onChange={(e) => {
                                handleProfileInput('state', e.target.value);
                            }}
                        /></Grid>
                    <Grid item xs={6}>
                        <TextField variant="outlined"
                            autoFocus
                            margin="dense"
                            label="Country"
                            fullWidth
                            value={profileInputs.country}
                            onChange={(e) => {
                                handleProfileInput('country', e.target.value);
                            }}
                        />
                    </Grid>
                </Grid>

                {
                    errorMessage && <Alert severity="success">{errorMessage}</Alert>
                }
            </DialogContent>
            <DialogActions>

                {/* <Button onClick={
                    () => {
                        setOpen(false);
                        setProfileOpen(false);
                        setResetEmailOpen(true);
                    }
                }
                    color="primary"
                >
                    Reset Email
                </Button>

                <Button onClick={() => {
                    sendPasswordResetEmail(auth, auth.currentUser.email)
                        .then(() => {
                            setErrorMessage("Reset password email sent!");
                        })
                        .catch((error) => {
                            const errorCode = error.code;
                            const errorMessage = error.message;
                            // ..
                        });
                }} color="primary">
                    Reset Password
                </Button> */}
                <Button onClick={handleClose} style={{ color: '#1EB0BC' }}>
                    Cancel
                </Button>
                <Button onClick={handleUpdateProfile} style={{ color: '#1EB0BC' }} disabled={firebaseLoading}>
                    Update
                </Button>
            </DialogActions>
        </Dialog>

        {/* Dialog for signup or login */}
        <Dialog open={open} aria-labelledby="form-dialog-title" style={{ width: 420, margin: 'auto' }}>
            <DialogTitle id="form-dialog-title" style={{ marginTop: 50, textAlign: 'center', fontSize: 16}}>{signingUp ? 'Sign up' : 'LOGIN'}
                {/* <Switch
                    checked={signingUp}
                    onChange={() => { setSigningUp(!signingUp) }}
                    name="signingUp"
                    color="default"
                /> */}
            </DialogTitle>
            <DialogContent style={{ marginLeft: 10, marginRight: 10 }}>
                <TextField variant="outlined"
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Email Address"
                    type="email"
                    fullWidth
                    value={userInputs.email}
                    onChange={(e) => {
                        handleUserInput('email', e.target.value);
                    }}
                    style={{ marginBottom: 10 }}
                />
                {signingUp && <TextField variant="outlined"
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Display Name"
                    type="text"
                    fullWidth
                    value={userInputs.displayName}
                    onChange={(e) => {
                        handleUserInput('displayName', e.target.value);
                    }}
                />}
                <TextField variant="outlined"
                    autoFocus
                    margin="dense"
                    id="password"
                    label="Password"
                    type="password"
                    fullWidth
                    value={userInputs.password}
                    onChange={(e) => {
                        handleUserInput('password', e.target.value);
                    }}
                    style={{ marginBottom: 10 }}
                />

                {signingUp && <TextField
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="password2"
                    label="Confirm Password"
                    type="password"
                    fullWidth
                    value={userInputs.password2}
                    onChange={(e) => {
                        handleUserInput('password2', e.target.value);
                    }}
                />}
                <Button onClick={handleLogin} disabled={firebaseLoading} variant="contained"
                    style={{ backgroundColor: '#1EB0BC', color: 'white', width: '100%', marginTop: 8 }}>
                    {signingUp ? 'Sign up' : 'Login'}
                </Button>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 1 }}>
                    <Button onClick={() => { setSigningUp(!signingUp) }} style={{ color: '#1EB0BC', fontSize: 10 }}>{signingUp ? 'Login' : 'Signup'}</Button>
                    <Button onClick={() => { setResetPasswordOpen(true); setOpen(false); }} style={{ color: '#1EB0BC', fontSize: 10 }}>Forgot password</Button>
                </Box>

                {
                    errorMessage && <Alert severity="error">{errorMessage}</Alert>
                }
            </DialogContent>
            <DialogActions style={{ marginLeft: 10, marginRight: 10 }}>
                <Button startIcon={<FcGoogle />} onClick={handleLoginWithGoogle} disabled={firebaseLoading} variant="outlined" style={{ width: '100%', marginLeft: 18, marginRight: 18, marginBottom: 80 }}>
                    Login with Google
                </Button>
                {/* <Button onClick={handleClose} color="primary">
                    Cancel
                </Button> */}
            </DialogActions>
        </Dialog>
    </div >

}

export default LoginButton;


// WEBPACK FOOTER //
// ./src/components/LoginButton/index.js